import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('revenueLine', 'revenueLines');

const customActions = {
  async LOAD_revenueLines({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('revenueLines')
      .query({
        $filter: 'IsDeleted eq false',
        $orderBy: 'Name',
      });
    commit('SET_revenueLines', data);
    return data;
  },
};

export default { ...actions, ...customActions };
